module.exports = __webpack_public_path__ + "media/icons/pochodzenie-sprowadzony-blue@2x-ee3dcae5.png";